import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";

interface ProtectedEvaRouteProps {
  children: React.ReactNode;
}

const ProtectedEvaRoute: React.FC<ProtectedEvaRouteProps> = ({ children }) => {
  const { userId } = useUser();

  // Check if the current user ID matches the allowed UUID
  const isAuthorized = userId === "02c73738-9481-4d0f-85c4-e927c6a09d09";

  if (!isAuthorized) {
    // Redirect to home page if not authorized
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedEvaRoute;
